import Header from './module/header';
import Footer from './module/footer';
import Map from './module/map';
import Modal from './module/modal';
import Scroll from './module/scroll';
import Top from './view/top';
import News from './view/news';
import mainvisualManager from './view/top/mainvisualManager';
// import mainvisualManagerSMP from './view/top/mainvisualManagerSMP';
import Faq from './view/faq';
import Recruit from './view/recruit';
import Outline from './view/outline';
import Business from './view/business';
import Jokatsu from './view/jokatsu';
import Brand from './view/brand-index';
import Inquiry from './view/inquiry';

let mainvisual = new mainvisualManager();
// let mainvisualSMP = new mainvisualManagerSMP();

$(document).ready(function(){
    if( Useragnt.userAgent.match(/10.10|msie|trident/) && !Useragnt.userAgent.match(/firefox/)){
        $('html').addClass('pc-other');
    }
});

window.addEventListener('load', () => {

    let _w = $(window).width();


    /* ==========================================

    -- debug mode

    ========================================== */

    // let arg = new Object;
    // let pair=location.search.substring(1).split('&');
    // for(let i=0;pair[i];i++) {
    //     let kv = pair[i].split('=');
    //     arg[kv[0]]=kv[1];
    // }
    //
    //
    // let _mode = (arg['debug']==='yes')?'debug':'normal';
    //
    // if(_mode==="debug"||location.href.match(/complete.html/g)){
    //
    //
    //     for(let i=0; i<$("a").length; i++){
    //         let _t = $("a").eq(i),
    //             _l = _t.attr("href");
    //
    //         let _p = "";
    //
    //         // if(_l.match(/http/g)&&!_l.match(/alpen-group.jp/g)) return;
    //
    //         if(_l!=="#"){
    //             if(_l.indexOf("?")!==-1) {
    //                 _p = _l.substring(_l.indexOf("?") + 1, _l.length);
    //
    //                 if(!_p.match(/debug/g)&&!_p.match(/#/g)) _t.attr("href", _l + "&debug=yes");
    //             }else if(_l.indexOf("#")!==-1) {
    //                 _p = _l.substring(_l.indexOf("#") + 1, _l.length);
    //                 // console.log("link",_l,_p);
    //
    //                 if(_l!=="#"+_p){
    //                     _l = _l.replace("#"+_p,"");
    //                     // console.log(_p);
    //                     // console.log("link",!_l);
    //                     if(!_l.match(/debug/g)) _t.attr("href",_l+"?debug=yes#"+_p);
    //                 }
    //
    //
    //             }else{
    //                 if(!_l.match(/debug/g)) _t.attr("href",_l+"?debug=yes");
    //
    //             }
    //         }
    //
    //     }
    //     for(let i=0; i<$("img").length; i++){
    //         let _t = $("img").eq(i),
    //             _l = _t.attr("src");
    //         _t.attr("src",_l+"?debug=yes");
    //
    //     }
    //
    //     if($("form")[0]){
    //         for(let i=0; i<$("form").length; i++){
    //             let _t = $("form").eq(i),
    //                 _l = _t.attr("action");
    //             _t.attr("action",_l+"?debug=yes");
    //
    //         }
    //     }
    //
    // }

    /* ======================================= */

    /* ==========================================

    -- hash

    ========================================== */
    let _hash = location.hash;
    if(_hash != '' && _hash != null && _hash != undefined){
        //if(_hash == '#tab' && _w < 750){
        if(_hash == '#tab'){
            let _position = $('.c-horizontal-nav').offset().top + $('.c-horizontal-nav__inner').height() - ($('#l-header__fixed').height()/1.5);

            setTimeout(function(){
                $('html,body').animate({scrollTop: _position}, 150);
            },1e2);
        }
    }

    /* ==========================================

     -- ID

     ========================================== */

    let pageID = $("body").attr("id").replace("p-","");

    switch (pageID) {
        case "top" :
            mainvisual.init();
        break;
    }

    /* ==========================================

     -- link

     ========================================== */

    $(".js__alllink").on("click",function () {
        location.href = $(this).find('a').attr("href");
    });

    /* ==========================================

     -- tablet tap

     ========================================== */

    if($('html.tablet')[0]) {

        var touched = false;
        var touch_time = 0;

        $("a").not($("#l-header__navi-list>ul>li>.l-header__meganavi-acc")).bind({
            'touchstart mousedown': function (e) {
                touched = true;
                touch_time = 0;
                document.interval = setInterval(function () {
                    touch_time += 100;
                    // 短すぎるタップとロングタップ時の処理
                    if (touch_time >= 750 || touch_time < 100) {
                        e.preventDefault();
                    }
                }, 100);
            },
            'touchend mouseup mouseout': function (e) { // マウスが領域外に出たかどうか
                var link = $(this).attr("href");
                var linktype = link.substring(0, 1);
                if (linktype != "#") {
                    if (touched) {
                        if (100 < touch_time < 750) {
                            var link = $(this).attr("href");
                            var target = $(this).attr("target");
                            var linktype = link.substring(0, 1);
                            if (target == "_blank") {
                                window.open(link);
                            } else {
                                location.href = link;
                            }
                        }
                    }
                    touched = false;
                    clearInterval(document.interval);
                    e.preventDefault();
                }
            }
        })

    }

    /* ==========================================

     -- page top

     ========================================== */

    let pagetopsvgMotion = function(){

        TweenMax.to($(".c-btn__pagetop polyline"),0.48,{
            drawSVG: "0%",
            repeat:-1,
            yoyo:true,
            // onRepeat:_onRepeat,
            repeatDelay:1
        });

    }

    if($(".c-btn__pagetop")[0]){
        pagetopsvgMotion();
    }

    /* ==========================================

     -- page scroll

     ========================================== */

    $(".c-btn__pagetop").on("click",function () {
        $('html,body').animate({scrollTop: 0}, 150);
        return false;
    });

    $("#l-kv-scrolldown").on("click",function () {
        let _position = $("#l-kv").height() - $('#l-header__fixed').height() + 3;
        $('html,body').animate({scrollTop: _position}, 280);
        return false;
    });

    /* ==========================================

     -- slice text

     ========================================== */

    let sliceText = $(".js__slice-text");
    let random = [],
        min = 1,
        max = 20;
    if(sliceText[0]){
        for (var i = 0; i < sliceText.length; i++){
            var text = new SplitText(sliceText.eq(i), {type: "words,chars"});
        }
        for (var i = 0; i < sliceText.length; i++){
            random = [];
            max = sliceText.eq(i).children().children().length;
            for (var j = 0; j < sliceText.eq(i).children().children().length; j++){
                random[j] = Math.floor( Math.random() * (max + 1 - min) ) + min;
                sliceText.eq(i).children().children().eq(j).addClass('delay'+random[j]);
            }
        }
    }

    /* ==========================================

     -- auto height

    ========================================== */

    if (_w < 750) {
      $(".js__height-line-pc2").attr('style','');
      $(".js__height-line-sp2").autoHeight({
          column: 2,
          reset: 'reset'
      });
    } else {
      $(".js__height-line-sp2").attr('style','');
      $(".js__height-line-pc2").autoHeight({
          column: 2,
          reset: 'reset'
      });
    }

    /* ==========================================

     -- font size

     ========================================== */

    // fontsize
    let Size = $.cookie('fontSize');
    if(Size) {
        $('#l-header__top-text__size>li').removeClass('select');
        if(Size == 's') {
            $('#l-header__top-text__size>li').eq(0).addClass('select');
            $('.l-body').css('font-size', '14px');
            $('body').addClass('font-s');
        }else if(Size == 'm') {
            $('#l-header__top-text__size>li').eq(1).addClass('select');
            $('.l-body').css('font-size', '16px');
            $('body').addClass('font-m');
        }else if(Size == 'l') {
            $('#l-header__top-text__size>li').eq(2).addClass('select');
            $('.l-body').css('font-size', '18px');
            $('body').addClass('font-l');
        }
    }
    $('#l-header__top-text__size>li').on('click',function() {
        $('#l-header__top-text__size>li').removeClass('select');
        $(this).addClass('select');
        let Size = $(this).data('fontsize');
        $.cookie('fontSize', Size);
        if(Size == 's') {
            $('.l-body').css('font-size', '14px');
            $('body').addClass('font-s');
        }else if(Size == 'm') {
            $('.l-body').css('font-size', '16px');
            $('body').addClass('font-m');
        }else if(Size == 'l') {
            $('.l-body').css('font-size', '18px');
            $('body').addClass('font-l');
        }
    });

    /* ==========================================

     -- header news

     ========================================== */

    if($('#header_entries')[0]){
        let _newsURL = "/corp_admin/mt/mt-data-api.cgi/v2/sites/8/entries?limit=3";
        //let _newsURL = "/mt/mt-data-api.cgi/v2/sites/8/entries?limit=3";
        let _html = '',_icon,_date,_pdf,_pdfURL;
        $.ajax({
            url: _newsURL,
            type: "GET",
            dataType: 'json'
        })
        .done(function( data ) {
             entryData(data);
        })
        .fail(function(data){
            //alert('お知らせ情報を取得できませんでした');
        });
        let entryData = function (data) {
            let clone = function (entry) {
                //entry.customFields[0] = PDF entry.customFields[1] = 外部リンク entry.customFields[2] = リンク先 entry.customFields[3] = アイコン
                if(entry.customFields[0].value !== '' && entry.customFields[0].value !== null){
                    _pdfURL = entry.customFields[0].value;
                    _pdfURL = _pdfURL.split('<a href="');
                    _pdfURL = _pdfURL[1].split('">');
                    _pdfURL = _pdfURL[0];
                    _icon = '<svg version="1.1" class="c-news__icon c-news__icon-pdf" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.122px" height="13px" viewBox="0 0 40.122 13" enable-background="new 0 0 40.122 13" xml:space="preserve"><path fill="#fff" d="M9,1v11H1V1H9 M10,0H0v13h10V0L10,0z"/><rect x="4" y="3" fill="#fff" width="5" height="1.979"/><path fill="#fff" d="M19.902,3.024h2.858c1.669,0,2.679,0.989,2.679,2.438c0,1.619-1.26,2.459-2.829,2.459h-1.169v2.099h-1.539V3.024z M22.66,6.552c0.77,0,1.22-0.459,1.22-1.079c0-0.69-0.479-1.06-1.249-1.06h-1.189v2.139H22.66z"/><path fill="#fff" d="M26.582,3.024h2.729c2.198,0,3.718,1.509,3.718,3.498c0,1.969-1.52,3.498-3.718,3.498h-2.729V3.024zM29.311,8.632c1.259,0,2.108-0.85,2.108-2.109c0-1.239-0.85-2.109-2.108-2.109h-1.189v4.218H29.311z"/><path fill="#fff" d="M34.402,3.024h5.327v1.399h-3.788v1.489h3.338v1.399h-3.338v2.709h-1.539V3.024z"/></svg>';
                }else if(entry.customFields[2].value !== '' && entry.customFields[2].value !== null){
                    if(entry.customFields[2].value.match(/.pdf/)) {
                        _pdfURL = entry.customFields[2].value;
                        _icon = '<svg version="1.1" class="c-news__icon c-news__icon-pdf" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.122px" height="13px" viewBox="0 0 40.122 13" enable-background="new 0 0 40.122 13" xml:space="preserve"><path fill="#fff" d="M9,1v11H1V1H9 M10,0H0v13h10V0L10,0z"/><rect x="4" y="3" fill="#fff" width="5" height="1.979"/><path fill="#fff" d="M19.902,3.024h2.858c1.669,0,2.679,0.989,2.679,2.438c0,1.619-1.26,2.459-2.829,2.459h-1.169v2.099h-1.539V3.024z M22.66,6.552c0.77,0,1.22-0.459,1.22-1.079c0-0.69-0.479-1.06-1.249-1.06h-1.189v2.139H22.66z"/><path fill="#fff" d="M26.582,3.024h2.729c2.198,0,3.718,1.509,3.718,3.498c0,1.969-1.52,3.498-3.718,3.498h-2.729V3.024zM29.311,8.632c1.259,0,2.108-0.85,2.108-2.109c0-1.239-0.85-2.109-2.108-2.109h-1.189v4.218H29.311z"/><path fill="#fff" d="M34.402,3.024h5.327v1.399h-3.788v1.489h3.338v1.399h-3.338v2.709h-1.539V3.024z"/></svg>';
                    }else if(entry.customFields[2].value.match(/http/)){
                        _pdfURL = entry.customFields[2].value;
                        _icon = '<svg class="c-news__icon c-news__icon-blank" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="5.5 -12 16 13"><path fill="#fff" d="M20.5-11v8h-11v-8m12-1h-13v10h13"/><path fill="#fff" d="M6.469.031v-7.015H5.5V1h10.969V.031z"/></svg>';
                    }else{
                        _pdfURL = entry.customFields[2].value;
                        _icon = '<svg version="1.1" class="c-news__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" width="20.946px" height="11.668px" viewBox="0 0 20.946 11.668" enable-background="new 0 0 20.946 11.668" xml:space="preserve"><line fill="none" stroke="#fff" stroke-miterlimit="10" x1="0" y1="5.834" x2="20" y2="5.834"/><polyline fill="none" stroke="#fff" stroke-miterlimit="10" points="15.337,11.334 20.274,5.834 15.337,0.334"/></svg>';
                    }
                }else{
                    _pdf = false;
                    _icon = '<svg version="1.1" class="c-news__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" width="20.946px" height="11.668px" viewBox="0 0 20.946 11.668" enable-background="new 0 0 20.946 11.668" xml:space="preserve"><line fill="none" stroke="#fff" stroke-miterlimit="10" x1="0" y1="5.834" x2="20" y2="5.834"/><polyline fill="none" stroke="#fff" stroke-miterlimit="10" points="15.337,11.334 20.274,5.834 15.337,0.334"/></svg>';
                }
                _html += '<article class="c-news__list">'
                if(entry.customFields[0].value !== '' && entry.customFields[0].value !== null){
                    _html += '<a href="' + _pdfURL + '" target="_blank">'
                }else if(entry.customFields[2].value !== '' && entry.customFields[2].value !== null){
                    if(entry.customFields[2].value.match(/.pdf/) || entry.customFields[2].value.match(/http/)) {
                        _html += '<a href="' + _pdfURL + '" target="_blank">'
                    }else{
                        _html += '<a href="' + _pdfURL + '">'
                    }
                }else{
                    _html += '<a href="' + entry.permalink + '">'
                }
                _html += '<div class="c-news__info">'
                _html += '<time class="c-news__time">' + _date+ '</time>'
                if(entry.categories[0]){
                    _html += '<p class="c-news__category">' + entry.categories[0].label + '</p>'
                }
                _html += '</div>'
                _html += '<div class="c-news__list-text">'
                _html += '<p>' + entry.title + '</p>'
                _html += '</div>'
                _html += _icon;
                _html += '</a>'
                _html += '</article>'
            }
            for (let i = 0; i < 3; i++) {
                let entry = data.items[i];
                //日付フォーマット変更
                _date = entry.date.split('T');
                _date = _date[0].replace(/-/g, ".");
                clone(entry);
                $('#header_entries .c-news__list-text p').text($(this).text().substr(0, 150));
            }
            $('#header_entries').append(_html);
            for (let i = 0; i < 3; i++) {
                let Cut = 40;
                let After = '…';
                let $Target = $('#header_entries').find('.c-news__list').eq(i).find('.c-news__list-text p');
                let Text = $Target.text();
                let Length = Text.length;
                Text = Text.substr(0, Cut);
                $Target.text(Text);
                if(Cut < Length) {
                    $Target.text(Text + After).css({visibility:'visible'});
                }else{
                    $Target.css({visibility:'visible'});
                }
            }
        }
    }

    /* facebookキャッシュクリア */
    $.post("https://graph.facebook.com/?scrape=true&id="+location.href);

}, false);

window.addEventListener('resize', () => {

    let _w = $(window).width();
    if (_w < 750) {
      $(".js__height-line-pc2").attr('style','');
      $(".js__height-line-sp2").autoHeight({
          column: 2,
          reset: 'reset'
      });
    } else {
      $(".js__height-line-sp2").attr('style','');
      $(".js__height-line-pc2").autoHeight({
          column: 2,
          reset: 'reset'
      });
    }

}, false);

let MOUSEWHEEL = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll' , delta;
$(document).on(MOUSEWHEEL,function(e){
    if(!$('body').hasClass('meganavi-open')) return;
    e.preventDefault();
    delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
    $('body').removeClass('meganavi-open');
    $('#l-header__navi-list>ul>li').removeClass('hover');
    TweenMax.to($(".l-header__meganavi"), 0.12, {
        y: '-5px',
        display: 'none',
        opacity:0,
        ease: Circ.easeOut
    });
    TweenMax.to($('#c-overlay'), 0.12, {
        display: 'none',
        opacity:0,
        ease: Circ.easeOut
    });
});

let getTrans = function(t) {
    var s = window.getComputedStyle(t.get(0));
    var m = s.getPropertyValue("-webkit-transform") || s.getPropertyValue("-moz-transform") || s.getPropertyValue("-ms-transform") || s.getPropertyValue("-o-transform") || s.getPropertyValue("transform");

    if (m === 'none') {
        m = 'matrix(0,0,0,0,0)';
    }else{
        m = m;
    }

    var val = m.match(/([-+]?[\d\.]+)/g);
    return val[14] || val[5] || 0;
};
